export default __webpack_public_path__ + "static/media/SAICE-Bookstore-gold.c5bdb9f3.png";